import React from 'react';

const Hash: React.VFC = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24.1666 9.58325V6.66658H18.3333V0.833252H15.4166V6.66658H9.58331V0.833252H6.66665V6.66658H0.833313V9.58325H6.66665V15.4166H0.833313V18.3333H6.66665V24.1666H9.58331V18.3333H15.4166V24.1666H18.3333V18.3333H24.1666V15.4166H18.3333V9.58325H24.1666ZM15.4166 15.4166H9.58331V9.58325H15.4166V15.4166Z" fill="#333333" />
  </svg>
);

export default Hash;
